import _ from 'lodash/fp';
import { createReducer } from 'reduxsauce';
import { BUDDIES, USER_ID } from 'actions/Base';

export const INITIAL_STATE = {
  isLoading: false,
};

export const onGetApprovedBuddiesRequest = (state) => ({ ...state, isLoading: true });
export const onGetApprovedBuddiesFailure = (state) => ({ ...state, isLoading: false });
export const onGetApprovedBuddiesSuccess = (state, { payload }) => {
  state.isLoading = false

  const id = payload.studentId;

  const friends = payload.data.content.map(i => {
    if (id===i.friend.id) return i.requester;
    return i.friend;
  })

  if(payload.data.pageable.pageNumber === 0) {
    payload.data.content = friends
    return _.set(USER_ID({ userType: payload.userType, id: payload.studentId }), payload.data)(state);
  }
  else {
    let current = _.cloneDeep(_.get(USER_ID({ userType: payload.userType, id: payload.studentId }))(state) || {});
    const contentArray = [ ...current.content, ...friends ]
    current = payload.data
    current.content = contentArray
    return _.set(USER_ID({ userType: payload.userType, id: payload.studentId }), current)(state);
  }
};

export const ACTION_HANDLERS = {
  [BUDDIES.GET_APPROVED_BUDDIES_REQUEST]: onGetApprovedBuddiesRequest,
  [BUDDIES.GET_APPROVED_BUDDIES_FAILURE]: onGetApprovedBuddiesFailure,
  [BUDDIES.GET_APPROVED_BUDDIES_SUCCESS]: onGetApprovedBuddiesSuccess
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
